"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cloneITxBuildCert = exports.normalizeITxBuildCert = void 0;
var cardano_ledger_ts_1 = require("@harmoniclabs/cardano-ledger-ts");
var CanBeData_1 = require("../utils/CanBeData.js");
var obj_utils_1 = require("@harmoniclabs/obj-utils");
;
;
function normalizeITxBuildCert(_a) {
    var cert = _a.cert, script = _a.script;
    if (!(0, obj_utils_1.isObject)(script) ||
        !(0, CanBeData_1.canBeData)(script.redeemer)) {
        script = undefined;
    }
    else if ((0, cardano_ledger_ts_1.isIUTxO)(script.ref)) {
        script = {
            ref: new cardano_ledger_ts_1.UTxO(script.ref),
            redeemer: (0, CanBeData_1.forceData)(script.redeemer)
        };
    }
    else {
        script = {
            inline: script.inline.clone(),
            redeemer: (0, CanBeData_1.forceData)(script.redeemer)
        };
    }
    return {
        cert: (0, cardano_ledger_ts_1.certificateFromCertificateLike)(cert),
        script: script
    };
}
exports.normalizeITxBuildCert = normalizeITxBuildCert;
/** @deprecated use `normalizeITxBuildCert` instead */
function cloneITxBuildCert(cert) {
    return normalizeITxBuildCert(cert);
}
exports.cloneITxBuildCert = cloneITxBuildCert;
